import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpoilerIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 11,
	viewBox: "0 0 19 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.9323 1.2634L17.932 1.26311L17.5628 0.893936L17.4565 0.787638L17.3505 0.894162L9.5022 8.7762C9.50099 8.77681 9.49859 8.77789 9.49464 8.77913C9.4847 8.78227 9.46974 8.78485 9.45095 8.78485C9.41689 8.78485 9.38493 8.77657 9.36311 8.7653L1.52624 0.894166L1.42025 0.787713L1.31395 0.893858L0.944239 1.26304L0.933624 1.27364L0.925318 1.28613C0.872307 1.36586 0.85 1.46325 0.85 1.54933C0.85 1.63087 0.870514 1.73639 0.943734 1.8102L0.944166 1.81064L9.16349 10.0294C9.16355 10.0295 9.16361 10.0295 9.16368 10.0296L9.16377 10.0297L9.26984 9.92364C9.37111 10.0255 9.53936 10.0255 9.60633 9.92364L17.9323 1.2634ZM17.9323 1.2634C18.0113 1.34281 18.0511 1.44822 18.0511 1.54933C18.0511 1.64528 18.014 1.75086 17.9234 1.81922L9.72148 10.0206L17.9323 1.2634Z",
		fill: "#4F4C4C",
		stroke: "#4F4C4C",
		strokeWidth: .3
	})
});
export { SvgSpoilerIcon as ReactComponent };
